// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vbcEq","toggleWrap":"styles_toggleWrap__1i3F7","content":"styles_content__2vEU0","selectAreaCode":"styles_selectAreaCode__3o2x8"};